import { cn } from "@/lib/utils";

interface AuthBrandMarkProps {
  appName: string;
  className?: string;
}

export function AuthBrandMark({ appName, className }: AuthBrandMarkProps) {
  return (
    <div className={cn("flex items-center justify-center gap-3", className)}>
      <div
        className="flex h-10 w-10 items-center justify-center rounded bg-secondary text-secondary-foreground ring-1 ring-outline-variant"
        aria-hidden="true"
        data-testid="auth-brand-logo"
      >
        <span className="font-display text-sm font-bold tracking-[0.08em]">CM</span>
      </div>
      <h1 className="font-display text-3xl font-bold tracking-display text-primary">{appName}</h1>
    </div>
  );
}
